<script>
	import {siteData} from './stores.js';
	let pw = $siteData.pw;


	import Legend 			from './Legend.svelte';
	import Introduction 	from './chapters/Introduction.svelte';
	import WatLeenstelsel 	from './chapters/WatLeenstelsel.svelte';
	import Spelregels 		from './chapters/Spelregels.svelte';
	import Rente 			from './chapters/Rente.svelte';
	import JouwSchuld 		from './chapters/JouwSchuld.svelte';
	import Opbouwfase 		from './chapters/OpbouwFase.svelte';
	import Aanloopfase 		from './chapters/AanloopFase.svelte';
	import Aflosfase 		from './chapters/AflosFase.svelte';
	import Einde 			from './chapters/Einde.svelte';
	import Footer 			from './Footer.svelte';
	import { updateData } 	from './data/updateData';
	import { onMount } 		from 'svelte';
	import scrollama 		from 'scrollama';
	import Empty 			from './Empty.svelte';

	updateData();
	onMount(() => {
	const scroller = scrollama();
	scroller	
		.setup({
			step: ".step"
		})
		.onStepEnter((response) => {
			//console.log("Entered step " + response.index);
			

        // Change legend to active
			if(response.index > 0){
				let newStep = document.querySelector('[data-chapter="' + response.index + '"]');   
				newStep.setAttribute('data-active', '1');
				//console.log(newStep);
			}
		})
		.onStepExit((response) => {
		
	    // Remove legend status
			if(response.index > 0){
				let newStep = document.querySelector('[data-chapter="' + response.index + '"]');   
				newStep.setAttribute('data-active', '0');
				//console.log(newStep);
			}
		});
	});
	
</script>

{#if $siteData.loggedIn }
        <div class="background"></div>

		<Legend />
 
        <div class="container">
            <Introduction />
			<WatLeenstelsel />
			<Spelregels />
			<Rente />
            <JouwSchuld />
			<Opbouwfase />
			<Aanloopfase />
			<Aflosfase />
			<Einde />
			<Footer />
		</div>
{:else if !siteData.loggedIn}

	<div class="background"></div>
	<Empty />

{/if}

